import { QuotationMetricsProps } from './quotation-metrics.types'

import { MarginMetrics } from '@/components'

export const QuotationMetrics = ({
  values,
  incomplete,
}: QuotationMetricsProps) => {
  return (
    <MarginMetrics
      incomplete={!!incomplete}
      cm3Margin={values?.cm3Margin || 0}
      grossMargin={values?.grossMargin || 0}
      hasWarehouseDiscount
    />
  )
}
